import React from 'react'

import { onEnter } from '../../utilities/accessibility/onEnter'

import '../../styles/scss/components/elements/checkbox.scss'

const Checkbox = ({ id, label, onChange, value }) => (
  <div className="checkbox">
    <input
      id={id}
      checked={value}
      name={label}
      onChange={onChange}
      onKeyDown={(event) => onEnter(event, onChange)}
      type="checkbox"
      value={value}
    />
    <label htmlFor={id}>{label}</label>
  </div>
)

export default Checkbox
